import { useMemo } from "react";

// Captures the essence of the EXAMPLE USE CASE sheet — an ETF analysed via
// Pord's Brain / Body / Application lens.
//
// Each holding is labelled with the *exact* category string from the source
// sheet so the analysis pivot below mirrors the original ETF lookup table.

const CAT = {
  BRAIN: "Brain",
  BODY: "Body",
  APP: "ai Adoption / Application",
  APP_NT: "ai Adoption / Application - Not Tech Sector",
  CASH: "Non US Stocks / or Cash",
};

const M = {
  GREEN: "GREEN",
  GREEN_YTD_DOWN: "GREEN 1M (+), YTD(-)",
  RED: "RED",
  NA: "#N/A",
};

const ETF_HOLDINGS = [
  { name: "NVIDIA Corporation", symbol: "NVDA", weight: 0.152268, cat: CAT.BRAIN, industry: "Semiconductors", m: M.GREEN },
  { name: "Apple Inc.", symbol: "AAPL", weight: 0.137199, cat: CAT.APP, industry: "Consumer Electronics", m: M.GREEN },
  { name: "Alphabet Inc. Class A", symbol: "GOOGL", weight: 0.06943, cat: CAT.APP_NT, industry: "Internet Content & Information", m: M.GREEN },
  { name: "Alphabet Inc. Class C", symbol: "GOOG", weight: 0.055952, cat: CAT.APP_NT, industry: "Internet Content & Information", m: M.GREEN },
  { name: "Micron Technology, Inc.", symbol: "MU", weight: 0.046504, cat: CAT.BRAIN, industry: "Semiconductors", m: M.GREEN },
  { name: "Advanced Micro Devices, Inc.", symbol: "AMD", weight: 0.044719, cat: CAT.BRAIN, industry: "Semiconductors", m: M.GREEN },
  { name: "Microsoft Corporation", symbol: "MSFT", weight: 0.036495, cat: CAT.BODY, industry: "Software - Infrastructure", m: M.GREEN_YTD_DOWN },
  { name: "Broadcom Inc.", symbol: "AVGO", weight: 0.033741, cat: CAT.BRAIN, industry: "Semiconductors", m: M.GREEN },
  { name: "Intel Corporation", symbol: "INTC", weight: 0.028591, cat: CAT.BRAIN, industry: "Semiconductors", m: M.GREEN },
  { name: "Meta Platforms Inc Class A", symbol: "META", weight: 0.025441, cat: CAT.APP_NT, industry: "Internet Content & Information", m: M.RED },
  { name: "Lam Research Corporation", symbol: "LRCX", weight: 0.02139, cat: CAT.BODY, industry: "Semiconductor Equipment & Materials", m: M.GREEN },
  { name: "Applied Materials, Inc.", symbol: "AMAT", weight: 0.019118, cat: CAT.BODY, industry: "Semiconductor Equipment & Materials", m: M.GREEN },
  { name: "Oracle Corporation", symbol: "ORCL", weight: 0.018375, cat: CAT.BODY, industry: "Software - Infrastructure", m: M.GREEN },
  { name: "Palantir Technologies Inc. Class A", symbol: "PLTR", weight: 0.016774, cat: CAT.BODY, industry: "Software - Infrastructure", m: M.GREEN_YTD_DOWN },
  { name: "Texas Instruments Inc.", symbol: "TXN", weight: 0.01539, cat: CAT.BRAIN, industry: "Semiconductors", m: M.GREEN },
  { name: "QUALCOMM Inc.", symbol: "QCOM", weight: 0.013942, cat: CAT.BRAIN, industry: "Semiconductors", m: M.GREEN },
  { name: "KLA Corporation", symbol: "KLAC", weight: 0.013595, cat: CAT.BODY, industry: "Semiconductor Equipment & Materials", m: M.GREEN },
  { name: "IBM", symbol: "IBM", weight: 0.013168, cat: CAT.BODY, industry: "Information Technology Services", m: M.GREEN },
  { name: "Sandisk Corporation", symbol: "SNDK", weight: 0.012583, cat: CAT.BODY, industry: "Computer Hardware", m: M.GREEN },
  { name: "Palo Alto Networks, Inc.", symbol: "PANW", weight: 0.01105, cat: CAT.BODY, industry: "Software - Infrastructure", m: M.GREEN },
  { name: "Analog Devices, Inc.", symbol: "ADI", weight: 0.010975, cat: CAT.BRAIN, industry: "Semiconductors", m: M.GREEN },
  { name: "Western Digital Corp.", symbol: "WDC", weight: 0.009685, cat: CAT.BODY, industry: "Computer Hardware", m: M.GREEN },
  { name: "Amphenol Corporation Class A", symbol: "APH", weight: 0.009658, cat: CAT.BODY, industry: "Electronic Components", m: M.GREEN },
  { name: "Marvell Technology, Inc.", symbol: "MRVL", weight: 0.009292, cat: CAT.BRAIN, industry: "Semiconductors", m: M.GREEN },
  { name: "CrowdStrike Holdings, Inc. Class A", symbol: "CRWD", weight: 0.008894, cat: CAT.BODY, industry: "Software - Infrastructure", m: M.GREEN },
  { name: "Salesforce, Inc.", symbol: "CRM", weight: 0.008608, cat: CAT.APP, industry: "Software - Application", m: M.GREEN_YTD_DOWN },
  { name: "Corning Inc.", symbol: "GLW", weight: 0.007657, cat: CAT.BODY, industry: "Electronic Components", m: M.GREEN },
  { name: "AppLovin Corp. Class A", symbol: "APP", weight: 0.007656, cat: CAT.APP_NT, industry: "Advertising Agencies", m: M.GREEN_YTD_DOWN },
  { name: "Vertiv Holdings Co.", symbol: "VRT", weight: 0.006407, cat: CAT.APP_NT, industry: "Electrical Equipment & Parts", m: M.GREEN },
  { name: "ServiceNow, Inc.", symbol: "NOW", weight: 0.006085, cat: CAT.APP, industry: "Software - Application", m: M.GREEN_YTD_DOWN },
  { name: "Cadence Design Systems, Inc.", symbol: "CDNS", weight: 0.005467, cat: CAT.APP, industry: "Software - Application", m: M.GREEN },
  { name: "Dell Technologies, Inc. Class C", symbol: "DELL", weight: 0.005305, cat: CAT.BODY, industry: "Computer Hardware", m: M.GREEN },
  { name: "Adobe Inc.", symbol: "ADBE", weight: 0.005304, cat: CAT.APP, industry: "Software - Application", m: M.GREEN_YTD_DOWN },
  { name: "Synopsys, Inc.", symbol: "SNPS", weight: 0.004918, cat: CAT.BODY, industry: "Software - Infrastructure", m: M.GREEN },
  { name: "Intuit Inc.", symbol: "INTU", weight: 0.00458, cat: CAT.APP, industry: "Software - Application", m: M.RED },
  { name: "Fortinet, Inc.", symbol: "FTNT", weight: 0.004301, cat: CAT.BODY, industry: "Software - Infrastructure", m: M.GREEN },
  { name: "Snowflake, Inc.", symbol: "SNOW", weight: 0.004251, cat: CAT.APP, industry: "Software - Application", m: M.GREEN },
  { name: "Cloudflare Inc Class A", symbol: "NET", weight: 0.003832, cat: CAT.BODY, industry: "Software - Infrastructure", m: M.GREEN },
  { name: "Datadog, Inc. Class A", symbol: "DDOG", weight: 0.003768, cat: CAT.APP, industry: "Software - Application", m: M.GREEN },
  { name: "Coherent Corp.", symbol: "COHR", weight: 0.003533, cat: CAT.BODY, industry: "Scientific & Technical Instruments", m: M.GREEN },
  // Representative cash / non-US allocation tail so the analysis is complete
  { name: "U.S. Dollar / Non-US holdings", symbol: "Other", weight: 0.05, cat: CAT.CASH, industry: "—", m: M.NA },
];

const fmtPct = (n) => `${(n * 100).toFixed(2)}%`;

// Roll-up helpers for the analysis table (matches the user's image)
const sumWeight = (predicate) =>
  ETF_HOLDINGS.filter(predicate).reduce((acc, h) => acc + h.weight, 0);

export default function UseCase() {
  const stamp = "Info as of 05·29·2026";

  // Compact 3-bucket summary used in the pivot cards
  const summary = useMemo(() => {
    const s = {
      Brain: { total: 0, green: 0, red: 0 },
      Body: { total: 0, green: 0, red: 0 },
      Application: { total: 0, green: 0, red: 0 },
    };
    for (const h of ETF_HOLDINGS) {
      let key = null;
      if (h.cat === CAT.BRAIN) key = "Brain";
      else if (h.cat === CAT.BODY) key = "Body";
      else if (h.cat === CAT.APP || h.cat === CAT.APP_NT) key = "Application";
      if (!key) continue;
      s[key].total += h.weight;
      if (h.m === M.RED) s[key].red += h.weight;
      else s[key].green += h.weight;
    }
    return s;
  }, []);

  const totalCovered =
    summary.Brain.total + summary.Body.total + summary.Application.total;

  // Analysis rows — mirrors the user-uploaded image exactly.
  const analysisRows = useMemo(() => {
    return [
      {
        holdings: "Brain",
        pricing: "GREEN",
        pricingTone: "green",
        weight: sumWeight((h) => h.cat === CAT.BRAIN && h.m === M.GREEN),
        group: 1,
      },
      {
        holdings: "Body",
        pricing: "GREEN",
        pricingTone: "green",
        weight: sumWeight((h) => h.cat === CAT.BODY && h.m === M.GREEN),
        group: 2,
      },
      {
        holdings: "Body",
        pricing: "GREEN 1M (+), YTD (-)",
        pricingTone: "green",
        weight: sumWeight(
          (h) => h.cat === CAT.BODY && h.m === M.GREEN_YTD_DOWN,
        ),
        group: 2,
      },
      {
        holdings: "Body",
        pricing: "RED",
        pricingTone: "red",
        weight: sumWeight((h) => h.cat === CAT.BODY && h.m === M.RED),
        group: 2,
      },
      {
        holdings: "ai Adoption / Application",
        pricing: "Total",
        pricingTone: "neutral",
        weight: sumWeight((h) => h.cat === CAT.APP),
        emphasize: true,
        group: 3,
      },
      {
        holdings: "ai Adoption / Application",
        pricing: "GREEN 1M (+), YTD (-)",
        pricingTone: "green",
        weight: sumWeight(
          (h) => h.cat === CAT.APP && h.m === M.GREEN_YTD_DOWN,
        ),
        group: 3,
      },
      {
        holdings: "ai Adoption / Application — Not Tech Sector",
        pricing: "Total",
        pricingTone: "neutral",
        weight: sumWeight((h) => h.cat === CAT.APP_NT),
        emphasize: true,
        group: 4,
      },
      {
        holdings: "ai Adoption / Application — Not Tech Sector",
        pricing: "GREEN 1M (+), YTD (-)",
        pricingTone: "green",
        weight: sumWeight(
          (h) => h.cat === CAT.APP_NT && h.m === M.GREEN_YTD_DOWN,
        ),
        group: 4,
      },
      {
        holdings: "Non US Stocks / or Cash",
        pricing: "#N/A",
        pricingTone: "muted",
        weight: sumWeight((h) => h.cat === CAT.CASH),
        group: 5,
      },
    ];
  }, []);

  return (
    <main
      data-testid="usecase-page"
      className="max-w-[1100px] mx-auto px-8 pt-16"
    >
      {/* Editorial poster */}
      <article
        data-testid="usecase-image"
        className="pord-card fade-in"
        style={{
          padding: "64px 56px",
          borderRadius: 8,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          aria-hidden
          style={{
            position: "absolute",
            top: -120,
            right: -80,
            width: 360,
            height: 360,
            borderRadius: "50%",
            background:
              "radial-gradient(closest-side, rgba(184,212,208,0.18), transparent 70%)",
            pointerEvents: "none",
          }}
        />

        <header className="mb-12">
          <div
            className="flex items-center justify-between mb-6"
            style={{ gap: 24 }}
          >
            <div className="eyebrow">Example use case · ETF lookup</div>
            <div className="eyebrow" data-testid="usecase-stamp">
              {stamp}
            </div>
          </div>

          <p
            data-testid="usecase-tagline"
            style={{
              color: "var(--pord-teal)",
              fontSize: "clamp(22px, 2.4vw, 32px)",
              lineHeight: 1.4,
              fontWeight: 300,
              maxWidth: 820,
              letterSpacing: "-0.005em",
              marginBottom: 24,
            }}
          >
            One ETF, read through the Brain · Body · Application lens.
          </p>

          <div className="flex flex-wrap items-center gap-3">
            <a
              data-testid="usecase-download-btn"
              href="/Pord-Look-Up-Sheet.pdf"
              download
              className="pord-btn pord-btn-fill"
            >
              <DownloadIcon /> Download Look-Up Sheet (PDF)
            </a>
            <span
              className="label-cap"
              style={{ color: "var(--pord-muted)" }}
            >
              · ETF · ABCDE
            </span>
          </div>
        </header>

        {/* Pivot summary */}
        <section
          data-testid="usecase-pivot"
          className="fade-in-d1"
          style={{ marginBottom: 56 }}
        >
          <div className="mb-6">
            <div
              className="label-cap"
              style={{ color: "var(--pord-sage)", marginBottom: 12 }}
              data-testid="pivot-heading"
            >
              Weight by functional positioning within the ai ecosystem
            </div>
            <p
              data-testid="pivot-description"
              style={{
                color: "var(--pord-muted)",
                fontSize: 15,
                lineHeight: 1.75,
                maxWidth: 760,
                margin: 0,
              }}
            >
              Totals show each group&rsquo;s weight in the fund; each one has
              different driven variables. Every line is a slice of the fund by
              holding-type &times; pricing-state, isolating the share whose
              1-month was up while the year-to-date was down — a shift in
              momentum of pricing and volatility.
            </p>
          </div>

          <PivotBar summary={summary} total={totalCovered} />

          <div
            className="grid mt-10 ref-category-grid"
            style={{
              gridTemplateColumns: "repeat(3, minmax(0,1fr))",
              gap: 24,
            }}
          >
            <PivotCard
              label="Brain"
              total={summary.Brain.total}
              green={summary.Brain.green}
              red={summary.Brain.red}
              note="Foundational compute, silicon, training stack."
              testid="pivot-brain"
            />
            <PivotCard
              label="Body"
              total={summary.Body.total}
              green={summary.Body.green}
              red={summary.Body.red}
              note="Infrastructure, software platforms, deployment."
              testid="pivot-body"
            />
            <PivotCard
              label="Application"
              total={summary.Application.total}
              green={summary.Application.green}
              red={summary.Application.red}
              note="End-user products integrating AI capability."
              testid="pivot-app"
            />
          </div>
        </section>

        <div className="divider mb-12" />

        {/* ANALYSIS TABLE — mirrors the user's image */}
        <section
          data-testid="usecase-analysis"
          className="fade-in-d2"
          style={{ marginBottom: 56 }}
        >
          <div className="flex items-baseline justify-between mb-6 gap-6 flex-wrap">
            <div>
              <div
                className="label-cap"
                style={{ color: "var(--pord-sage)", marginBottom: 6 }}
              >
                Analysis
              </div>
              <div
                className="headline"
                style={{ fontSize: 22, color: "var(--pord-text)" }}
              >
                Holdings · Pricing · Weight
              </div>
            </div>
          </div>

          {/* Grouped analysis cards */}
          {[1, 2, 3, 4, 5].map((groupNum) => {
            const groupRows = analysisRows.filter((r) => r.group === groupNum);
            if (groupRows.length === 0) return null;
            const groupLabel = groupRows[0].holdings;
            const groupColors = {
              1: "rgba(155,199,164,0.08)",
              2: "rgba(184,212,208,0.05)",
              3: "rgba(184,212,208,0.06)",
              4: "rgba(200,180,160,0.05)",
              5: "rgba(163,163,163,0.04)",
            };
            const accentColors = {
              1: "rgba(155,199,164,0.5)",
              2: "rgba(184,212,208,0.35)",
              3: "rgba(184,212,208,0.45)",
              4: "rgba(200,180,160,0.4)",
              5: "rgba(163,163,163,0.3)",
            };
            return (
              <div
                key={groupNum}
                style={{
                  background: groupColors[groupNum],
                  border: "1px solid rgba(184,212,208,0.08)",
                  borderLeft: `3px solid ${accentColors[groupNum]}`,
                  borderRadius: 10,
                  overflow: "hidden",
                  marginBottom: 12,
                }}
              >
                {/* Group label */}
                <div
                  style={{
                    padding: "14px 24px 10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    className="label-cap"
                    style={{ color: "var(--pord-sage)", fontSize: 10 }}
                  >
                    Group {groupNum}
                  </span>
                  <span
                    style={{
                      color: "var(--pord-teal)",
                      fontSize: 12,
                      fontWeight: 400,
                      letterSpacing: "0.02em",
                      opacity: 0.7,
                    }}
                  >
                    {groupLabel.length > 30 ? groupLabel.slice(0, 30) + "..." : groupLabel}
                  </span>
                </div>

                {/* Column header */}
                <div
                  className="grid label-cap"
                  style={{
                    gridTemplateColumns: "1.8fr 1.2fr 100px",
                    gap: 16,
                    padding: "8px 24px",
                    color: "rgba(184,212,208,0.3)",
                    fontSize: 9,
                  }}
                >
                  <div>Holdings</div>
                  <div>Pricing</div>
                  <div style={{ textAlign: "right" }}>Weight</div>
                </div>

                {/* Rows */}
                {groupRows.map((r, i) => (
                  <div
                    key={`${r.holdings}-${r.pricing}-${i}`}
                    data-testid={`analysis-row-g${groupNum}-${i}`}
                    className="grid row-hover"
                    style={{
                      gridTemplateColumns: "1.8fr 1.2fr 100px",
                      gap: 16,
                      padding: "14px 24px",
                      alignItems: "center",
                      borderTop: i > 0 ? "1px solid rgba(184,212,208,0.04)" : "none",
                    }}
                  >
                    <div
                      style={{
                        color: "var(--pord-text)",
                        fontSize: 14,
                        fontWeight: r.emphasize ? 400 : 300,
                      }}
                    >
                      {r.holdings}
                    </div>
                    <div>
                      <PricingPill pricing={r.pricing} tone={r.pricingTone} />
                    </div>
                    <div
                      style={{
                        textAlign: "right",
                        fontVariantNumeric: "tabular-nums",
                        color: "var(--pord-text)",
                        fontSize: 14,
                        fontWeight: 400,
                      }}
                    >
                      {fmtPct(r.weight)}
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
        </section>

        <div className="divider mb-12" />

        {/* Holdings table */}
        <section data-testid="usecase-holdings" className="fade-in-d3">
          <div className="flex items-baseline justify-between mb-6">
            <div className="label-cap" style={{ color: "var(--pord-sage)" }}>
              Holdings · top {ETF_HOLDINGS.length}
            </div>
            <div className="label-cap" style={{ color: "var(--pord-muted)" }}>
              Sorted by weight
            </div>
          </div>

          <div
            className="hidden md:grid label-cap"
            style={{
              gridTemplateColumns: "1.6fr 80px 90px 110px 1.4fr 80px",
              gap: 18,
              color: "var(--pord-sage)",
              padding: "0 0 14px 0",
            }}
          >
            <div>Holding</div>
            <div>Symbol</div>
            <div style={{ textAlign: "right" }}>Weight</div>
            <div>Layer</div>
            <div>Industry</div>
            <div style={{ textAlign: "right" }}>1M</div>
          </div>
          <div className="divider" />

          <ul className="ref-holdings-list">
            {ETF_HOLDINGS.map((h) => (
              <li
                key={h.symbol + h.name}
                style={{ borderBottom: "1px solid rgba(184,212,208,0.06)" }}
              >
                <div
                  className="grid"
                  style={{
                    gridTemplateColumns: "1.6fr 80px 90px 110px 1.4fr 80px",
                    gap: 18,
                    padding: "16px 0",
                    alignItems: "center",
                  }}
                >
                  <div style={{ fontSize: 15 }}>{h.name}</div>
                  <div
                    style={{
                      color: "var(--pord-teal)",
                      fontSize: 13,
                      fontWeight: 400,
                      letterSpacing: "0.04em",
                    }}
                  >
                    {h.symbol}
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      fontVariantNumeric: "tabular-nums",
                      color: "var(--pord-text)",
                      fontSize: 14,
                    }}
                  >
                    {fmtPct(h.weight)}
                  </div>
                  <div>
                    <SmallCatBadge cat={h.cat} />
                  </div>
                  <div style={{ color: "var(--pord-muted)", fontSize: 13 }}>
                    {h.industry}
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <MomentumDot m={h.m} />
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </section>

        <footer className="mt-16">
          <div className="divider mb-8" />
          <p
            style={{
              color: "var(--pord-muted)",
              fontSize: 14,
              maxWidth: 640,
              lineHeight: 1.75,
            }}
          >
            Source · representative composition based on the dataset's holdings
            sheet. Pord. does not manage funds — this is a way of reading them.
          </p>
        </footer>
      </article>
    </main>
  );
}

function PivotBar({ summary, total }) {
  const w = (n) => (total > 0 ? (n / total) * 100 : 0);
  return (
    <div
      data-testid="pivot-bar"
      style={{
        display: "flex",
        height: 14,
        borderRadius: 999,
        overflow: "hidden",
        background: "rgba(184,212,208,0.06)",
      }}
    >
      <div
        style={{
          width: `${w(summary.Brain.total)}%`,
          background: "var(--pord-teal)",
        }}
      />
      <div
        style={{
          width: `${w(summary.Body.total)}%`,
          background: "var(--pord-sage)",
        }}
      />
      <div
        style={{
          width: `${w(summary.Application.total)}%`,
          background: "#cfd8d4",
        }}
      />
    </div>
  );
}

function PivotCard({ label, total, green, red, note, testid }) {
  return (
    <div
      data-testid={testid}
      className="pord-card-flat"
      style={{ padding: 24, borderRadius: 6 }}
    >
      <div className="flex items-baseline justify-between mb-3">
        <div className="label-cap" style={{ color: "var(--pord-teal)" }}>
          {label}
        </div>
        <SmallCatBadge cat={label} />
      </div>
      <div
        className="headline"
        style={{ fontSize: 40, color: "var(--pord-text)", marginBottom: 12 }}
      >
        {fmtPct(total)}
      </div>
      <div className="flex items-center gap-4 mb-4">
        <span
          className="flex items-center gap-2"
          style={{
            color: "#bcd9c2",
            fontSize: 11,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
          }}
        >
          <span className="dot dot-green" /> {fmtPct(green)}
        </span>
        <span
          className="flex items-center gap-2"
          style={{
            color: "#e0b6b6",
            fontSize: 11,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
          }}
        >
          <span className="dot dot-red" /> {fmtPct(red)}
        </span>
      </div>
      <p
        style={{
          color: "var(--pord-muted)",
          fontSize: 13,
          lineHeight: 1.7,
        }}
      >
        {note}
      </p>
    </div>
  );
}

const CAT_STYLE = {
  Brain: { fg: "var(--pord-teal)", bd: "rgba(184,212,208,0.45)" },
  Body: { fg: "var(--pord-sage)", bd: "rgba(154,173,168,0.45)" },
  "ai Adoption / Application": {
    fg: "#cfd8d4",
    bd: "rgba(207,216,212,0.30)",
  },
  "ai Adoption / Application - Not Tech Sector": {
    fg: "#b8c4c1",
    bd: "rgba(184,196,193,0.25)",
  },
  "Non US Stocks / or Cash": {
    fg: "rgba(255,255,255,0.55)",
    bd: "rgba(184,212,208,0.18)",
  },
  Application: { fg: "#cfd8d4", bd: "rgba(207,216,212,0.30)" },
};

const CAT_SHORT = {
  Brain: "Brain",
  Body: "Body",
  "ai Adoption / Application": "ai Adopt / App",
  "ai Adoption / Application - Not Tech Sector": "ai App · Not Tech",
  "Non US Stocks / or Cash": "Non US / Cash",
  Application: "Application",
};

function SmallCatBadge({ cat }) {
  const t = CAT_STYLE[cat] || CAT_STYLE.Application;
  const label = CAT_SHORT[cat] || cat;
  return (
    <span
      style={{
        display: "inline-block",
        padding: "4px 10px",
        borderRadius: 999,
        border: `1px solid ${t.bd}`,
        color: t.fg,
        fontSize: 9,
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}

function MomentumDot({ m }) {
  if (m === M.NA) {
    return (
      <span
        style={{
          color: "var(--pord-muted)",
          fontSize: 10,
          letterSpacing: "0.18em",
        }}
      >
        N/A
      </span>
    );
  }
  if (m === M.RED) return <span className="dot dot-red" />;
  // both GREEN variants render a green dot in this column
  return <span className="dot dot-green" />;
}

function PricingPill({ pricing, tone }) {
  const map = {
    green: { fg: "#bcd9c2", bd: "rgba(155,199,164,0.35)", dot: "dot-green" },
    red: { fg: "#e0b6b6", bd: "rgba(208,154,154,0.35)", dot: "dot-red" },
    neutral: {
      fg: "var(--pord-text)",
      bd: "rgba(184,212,208,0.22)",
      dot: null,
    },
    muted: {
      fg: "var(--pord-muted)",
      bd: "rgba(184,212,208,0.14)",
      dot: null,
    },
  };
  const t = map[tone] || map.neutral;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "5px 11px",
        borderRadius: 999,
        border: `1px solid ${t.bd}`,
        color: t.fg,
        fontSize: 10,
        letterSpacing: "0.14em",
        textTransform: "uppercase",
        whiteSpace: "nowrap",
      }}
    >
      {t.dot && <span className={`dot ${t.dot}`} />}
      {pricing}
    </span>
  );
}

function DownloadIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );
}
